import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------invoice page api's-------------------------------->
    getInvoices(page, count, search, status, sort, label, from_date, to_date, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/invoice/' + page + '/' + count + '?search=' + search + '&status=' + status + '&from_date=' + from_date + '&to_date=' + to_date + '&sort=' + sort + '&label=' + label + '&custom=' + custom)
    },
    getInvoiceExport(page, count, search, status, sort, label, from_date, to_date, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/invoice/export/' + page + '/' + count + '?search=' + search + '&status=' + status + '&from_date=' + from_date + '&to_date=' + to_date + '&sort=' + sort + '&label=' + label + '&custom=' + custom)
    },
    /**
     * 
     * @param {*} form 
     */
    postInvoice(form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/create', form)
    },
    /**
     * bulk delete api 
     */
    postInvoiceBulkDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/bulkdelete', data)
    },
    /**
     * 
     * @param {*} data 
     */
    postFiltercreateInvoice(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/filtercreate', data)
    },
    /**
     * credits and excess amount available for customer
     * @param {*} data 
     */
    postcreditsavailable(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/customercredits', data)
    },
    /**
     * retainer  amount available for customer
     * @param {*} data 
     */
    postretaineravailable(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/customerretainer', data)
    },
    /**
     * handling the available credits used amount api
     * @param {*} data 
     */
    postUsedCreditUpdate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/creditsapplied/creditamount', data)
    },
    /**
     * handling the available credits used amount api
     * @param {*} data 
     */
    postUsedRetainerUpdate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/creditsapplied/retaineramount', data)
    },
    postDeleteCreditPayment(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/creditsapplied/creditdelete', data)
    },


    /**
     * 
     * @param {*} data 
     * @param {*} id 
     */
    postFilterudpateInvoice(data, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/filterupdate/' + id, data)
    },
    /**
     * 
     * @param {*} data 
     */
    postFilterdeleteInvoice(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/filterdelete', data)
    },
    /**
     * 
     * @param {*} data 
     */
    postInvoiceCancel(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/cancel', data)
    },
    /**
     * 
     * @param {*} id 
     */
    getInvoiceView(id, page,type, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        var url = 'invoiceview/' + id+'?type='+type;
        if (page == 'order') {
            url = 'invoiceview/' + id + '?sales_order=""'+'&type='+type
        }
        return apiClient.get('/invoice/' + url)
    },
    /**
     * 
     * @param {*} id 
     */
    getInvoice(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/invoice/view/' + id)
    },
    /**
     * 
     * @param {*} form 
     * @param {*} id 
     */
    postInvoiceUpdate(form, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/update/' + id, form)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    postPaymentUpdate(id, form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/updatePayment/' + id, form)
    },
    postdeletepaymentreason(form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/deletepaymentreason', form)
    },
    postdeletepayment(form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/deletepayment', form)
    },
    /**
     * 
     * @param {*} id 
     */
    postComplete(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/updateComplete/' + id)
    },

    /**
     * 
     * @param {*} id 
     */
    postReceiptOrder(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/orders/receipt', id)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getInvoiceDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/singledelete', data)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getInvoiceApprove(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/statusapproval', data)
    },
    getInvoiceCancel(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/cancel', data)
    },
    /**
     * check for whether creating credits from this invoice are allowed or not
     */
    postallowcredits(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/allowcredits', data)
    },
    /**
     *  get the list for creating credits
     * @param {id} data 
     * @param {page} token 
     */
    getCreditView(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/CreditView', data)
    },
    postMailDetails(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/mail/details', data)
    },
    postMailDatas(datas, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/mail/getActualMailContent', datas)
    },
    writeoffinvoice(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/writeoff', data)
    },
    addeway(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/invoice/EwayBillCreate', data)
    },
}